import { ACTIVE_STATUS, AssignmentEntityType, FUTURE_STATUS, useAssignmentService } from 'domain/shared/assignment';
import { DESC } from 'framework/list';
import type { CollectionViewParamsConfig } from 'framework/ViewTypes';
import { type FilterState } from 'framework/ViewTypes/components';
import { FilterCondition } from 'framework/types';
import { useCollectionPager } from 'framework/ViewTypes/hooks';

const VIEW_PARAMS_CONFIG: CollectionViewParamsConfig<FilterState> = {
  defaultFilters: { status: { in: [ACTIVE_STATUS] } },
  defaultSortBy: 'updatedAt',
  defaultSortOrder: DESC,
  cache: true,
  filterRules: {
    bench: { condition: FilterCondition.EQ, values: ['YES', 'NO'] },
    isVirtual: { condition: FilterCondition.EQ, values: ['YES', 'NO'] },
    isPending: { condition: FilterCondition.EQ, values: ['YES', 'NO'] },
    status: { condition: FilterCondition.IN, values: [ACTIVE_STATUS, FUTURE_STATUS] },
    'owner.alias': { condition: FilterCondition.EQ },
    'specification:individualAssignmentsByEmployeeAlias': { condition: FilterCondition.EQ },
    'specification:backupForEmployeeAlias': { condition: FilterCondition.EQ },
    'specification:groupAssignmentsByGroupId': { condition: FilterCondition.IN },
    'createdBy.alias': { condition: FilterCondition.EQ },
    'specification:assignmentsByPositionIds': { condition: FilterCondition.IN },
    'technology.id': { condition: FilterCondition.IN },
    'project.id': { condition: FilterCondition.EQ },
    serviceId: { condition: FilterCondition.EQ },
    from: { condition: [FilterCondition.GE, FilterCondition.LE] },
    to: { condition: [FilterCondition.GE, FilterCondition.LE] },
  },
  sortableColumns: ['updatedAt', 'id', 'ownerNameEn', 'backupForEmployeeId', 'from', 'to', 'minPercent', 'maxPercent'],
};

const useAssignmentsCollection = () => {
  const { search } = useAssignmentService();

  return useCollectionPager<AssignmentEntityType, FilterState>({
    pageSize: 30,
    viewParamsConfig: VIEW_PARAMS_CONFIG,
    fetchPage: ({ pageNumber, pageSize, filters, sort, signal }) =>
      search({ pageNumber, pageSize, filter: filters, sort }, { signal }),
  });
};

export default useAssignmentsCollection;
